import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function detranCrvClear(): ReducerAction {
	return {
		type: Types.DETRAN_CRV_CLEAR,
		payload: null,
	};
}
